import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useClinicalDemo } from '../../contexts/ClinicalDemoContext';
import { categoryInfo, clinicalPatient, clinicalScopeNote, visits } from '../../data/clinicalDemo';
import type { EntryCategory } from '../../types/clinicalDemo';
import { formatDate } from '../../utils/demoStorage';
import { glassPanel, linkButton } from '../../utils/demoUi';
import { visitStatus, visitStatusLabels } from '../../utils/clinicalDemo';
import { CategoryTag } from './CategoryTag';
export function ClinicalOverview() {
  const {
    state,
    dispatch
  } = useClinicalDemo();
  const reviewer = state.ui.workspace === 'review';
  return <div data-id="element-121" data-mp="31jm2ep8leqvk">
      <p className="text-sm font-medium text-lavender" data-id="element-122" data-mp="31jufah4ptw6r">Fictional record · {clinicalPatient.id}</p>
      <h1 className="mt-1 font-heading text-3xl font-bold tracking-tight text-ink-dark lg:text-4xl" data-id="element-123" data-mp="36e8hp3hsp3kx">{clinicalPatient.name}</h1>
      <p className="mt-2 text-ink-muted" data-id="element-124" data-mp="2dvkzpwy3i4o2">{clinicalPatient.description}</p>

      <ul className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2" data-id="element-125" data-mp="2dtrsogjklifj">
        {visits.map(visit => {
        const status = visitStatus(state, visit.id);
        const count = state.entries.filter(entry => entry.visitId === visit.id).length;
        return <li key={visit.id} className={`${glassPanel} flex flex-col p-6`} data-id="element-126" data-mp="2was8i9mb8o0n">
              <p className="text-xs text-ink-muted" data-id="element-127" data-mp="2rc8mk97pvc8a">
                {visit.id} · {formatDate(visit.date)}
              </p>
              <h2 className="mt-1 font-heading text-lg font-bold text-ink-dark" data-id="element-128" data-mp="2nczqgxp7f29k">{visit.label}</h2>
              <p className="mt-1 text-sm text-ink-muted" data-id="element-129" data-mp="2ibadhcif8eiu">
                {count} entries · {visitStatusLabels[status]}
              </p>
              <div className="mt-auto flex flex-wrap gap-4 pt-4" data-id="element-130" data-mp="28enu6s5qtvix">
                <button type="button" onClick={() => dispatch({
              type: 'selectVisit',
              visitId: visit.id,
              section: 'timeline'
            })} className={linkButton} data-id="element-131" data-mp="28g8s8rr9nwlj">
                  Open in timeline
                  <ArrowRight size={14} aria-hidden="true" data-id="element-132" data-mp="6nkhzyg7g8w9" />
                </button>
                {reviewer && status !== 'reviewed' && <button type="button" onClick={() => dispatch({
              type: 'selectVisit',
              visitId: visit.id,
              section: 'review'
            })} className={linkButton} data-id="element-133" data-mp="25tpun9nj87c3">
                    Review documentation
                    <ArrowRight size={14} aria-hidden="true" data-id="element-134" data-mp="1w46cy7bk2jit" />
                  </button>}
              </div>
            </li>;
      })}
      </ul>

      <section aria-labelledby="categories-title" className="mt-10" data-id="element-135" data-mp="2juk846pfsyhm">
        <h2 id="categories-title" className="font-heading text-lg font-bold text-ink-dark" data-id="element-136" data-mp="2orixyd22ija0">
          Record categories
        </h2>
        <dl className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-2" data-id="element-137" data-mp="2av5eiydz47sw">
          {(Object.keys(categoryInfo) as EntryCategory[]).map(category => <div key={category} className="rounded-lg border border-line bg-white/80 px-4 py-3" data-id="element-138" data-mp="zdnv1kjtm4xt">
              <dt data-id="element-139" data-mp="13fr9mi1sdpnb">
                <CategoryTag category={category} data-id="element-140" data-mp="13gaf2za92lkg" />
              </dt>
              <dd className="mt-1.5 text-sm text-ink-muted" data-id="element-141" data-mp="vvgmudosksdd">{categoryInfo[category].description}</dd>
            </div>)}
        </dl>
      </section>

      <p className="mt-8 rounded-lg border-l-4 border-teal bg-teal-pale px-4 py-3 text-sm leading-relaxed text-ink-dark" data-id="element-142" data-mp="qyzpqtzm73o5">{clinicalScopeNote}</p>
    </div>;
}